import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Img from "gatsby-image/withIEPolyfill"
import TransitionLink from "gatsby-plugin-transition-link"

import { TYPE, COLORS } from "../../../theme/styles/globals"

export default class ArticleCard extends React.Component {

    slashString(arr) {
        let s = ""
        arr.map((e, i) => s += `${e} / `)
        return s.substring(0, s.length - 2)
    }

    render() {

        const { image, title, short, slug, transition, stacked, mode } = this.props

        return (
            <Container
                to={`/articles/${slug}`}
                exit={transition.exit}
                entry={transition.entry}
                mode={mode}
                stacked={stacked}
            >
                <TextWrap
                    stacked={stacked}
                >
                    <Title>{title}</Title>
                    <Short>{short}</Short>
                </TextWrap>
                <ImageWrap>
                    <Image fluid={image.fluid} />
                </ImageWrap>
            </Container>
        )

    }

}

const Image = styled(Img)`
    width:100%;
    height:100%;
    transition: all 0.2s ease-in-out;
    opacity: 0.7;
`

const TextWrap = styled.div`
    width:90%;
    position:absolute;
    z-index:2;
    padding:20px;
    bottom:1vw;

    ${up('md')}{
      padding:0px;
      //top:50%;
      margin-top:-2vh;
      transform:translateX(-7vh);

      ${props => props.stacked === `vertical` ? `
        margin-top:-2vh;
      ` : `

      `}
      
      ${props => props.stacked === `grid` ? `
        margin-top:5vh;
        transform:translateX(3vh);
      ` : `

      `}
      
      ${props => props.stacked === `horizontal` ? `
        margin-top:10vh;
      ` : `

      `}
    }
`

const ImageWrap = styled.div`
    width:100%;
    height:100%;
    position:absolute;
    top:0px;
    left:0px;
    overflow:hidden;
    z-index:1;
`

const Title = styled.h3`
    margin:0;
    padding:0;
    font-family:${TYPE.SERIF_BOLD_FONT};
    color:white;
    font-size:28px;
    font-weight:normal;

    ${up('md')}{
      font-size:1.4vw;
    }
`

const Short = styled.p`
    margin:0;
    padding:0;
    font-family:${TYPE.SERIF_FONT};
    color:white;
    font-size:16px;
    font-weight:normal;
    margin-top:1vw;

    ${up('md')}{
      font-size:1vw;
      margin-top:0.3vw;
    }
`

const Container = styled(TransitionLink)`
    width:100%;
    height:460px;
    background:black;
    display:block;
    position:relative;

    ${up('md')}{

        ${props => props.stacked === `vertical` ? `
            height:30vh;
            width:40vh;
            margin:1vh;
        ` : ``}
        
        ${props => props.stacked === `grid` ? `
            height:14vw;
            width:24vw;
            display:flex;
        ` : ``}
        
        ${props => props.stacked === `horizontal` ? `
            @media (min-height: 400px) {
                height:75vh;
                width:50vh;
            }
            
            @media (min-height: 1000px) {
                height:60vh;
                width:40vh;
            }
            margin:10vh 0vh 10vh 10vh;
            display:flex;
        ` : ``}
         
    }

    &:hover {
        ${Image} {
            transform: scale(1.1);
            opacity: 0.5;
        }
    }

`

